import { render, staticRenderFns } from "./RecentlyActiveRepoList.vue?vue&type=template&id=00b5a7d9"
import script from "./RecentlyActiveRepoList.vue?vue&type=script&lang=ts"
export * from "./RecentlyActiveRepoList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AnalyzerLogo: require('/app/components/AnalyzerLogo.vue').default,ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,ListItem: require('/app/components/TeamHome/ListItem.vue').default,ZButton: require('/app/components/zeal/ZButton/ZButton.vue').default,EmptyState: require('/app/components/Common/EmptyState.vue').default,AddRepoModal: require('/app/components/AddRepo/AddRepoModal.vue').default})
